<template>
  <div class="row y-gap-30">
    <!------Top Card------------>
    <div class="col-lg-12 col-md-12">
      <router-link to="/blogs/1" class="blogCard -type-1">
        <div class="blogCard__image">
          <img class="w-1/1 rounded-8" src="../../assets/images/home/blog-1.png" alt="image" width="788" height="450" />
        </div>
        <div class="blogCard__content-first mt-20">
          <h4 class="blogCard__title text-32 mb-15">
            Delay Analysis & EOT Claims
          </h4>

          <div class="d-flex align-items-center blog-owner">
            <div class="blogCard__category d-flex justify-center align-items-center rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.00146 2.32039C7.32658 2.32039 5.96883 3.67814 5.96883 5.35301C5.96883 7.02787 7.32658 8.38562 9.00146 8.38562C10.6763 8.38562 12.0341 7.02787 12.0341 5.35301C12.0341 3.67814 10.6763 2.32039 9.00146 2.32039ZM4.48242 5.35301C4.48242 2.85722 6.50567 0.833984 9.00146 0.833984C11.4973 0.833984 13.5205 2.85722 13.5205 5.35301C13.5205 7.84879 11.4973 9.87203 9.00146 9.87203C6.50567 9.87203 4.48242 7.84879 4.48242 5.35301Z"
                  fill="#94AD04" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M3.33248 12.9313C4.69064 12.1206 6.52819 11.5806 9.00157 11.5806C11.4749 11.5806 13.3125 12.1206 14.6707 12.9313C16.0294 13.7424 16.8649 14.7984 17.374 15.7622L17.374 15.7623C17.8295 16.6249 17.6805 17.5199 17.1634 18.1691C16.6661 18.7936 15.8567 19.1664 14.9877 19.1664H3.01542C2.14646 19.1664 1.33699 18.7936 0.839673 18.1691C0.322636 17.5198 0.17361 16.6249 0.629184 15.7623C1.1382 14.7985 1.97374 13.7424 3.33248 12.9313ZM4.09434 14.2076C3.00486 14.8579 2.34588 15.6946 1.94355 16.4564L1.94354 16.4564C1.77957 16.7669 1.83173 17.0288 2.00244 17.2432C2.19287 17.4823 2.5577 17.68 3.01542 17.68H14.9877C15.4454 17.68 15.8102 17.4823 16.0007 17.2432C16.1714 17.0288 16.2236 16.7669 16.0596 16.4564C15.6573 15.6946 14.9983 14.8579 13.9088 14.2076C12.8187 13.5569 11.2544 13.067 9.00157 13.067C6.74877 13.067 5.1844 13.5569 4.09434 14.2076Z"
                  fill="#94AD04" />
              </svg>
            </div>
            <div>
              <h4 class="blogCard__title text-16 lh-15 fw-500">
                By Ali Katary, Expert Engineer.
              </h4>
              <div class="blogCard__date mt-5 text-16">Jan 22, 2024</div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
    <!----------Next 4 components------------->
    <div class="col-md-6">
      <router-link to="/blogs/1" class="blogCard -type-1">
        <div class="blogCard__image">
          <img class="w-1/1 rounded-8" src="../../assets/images/home/blog-1.png" alt="image" width="788" height="450" />
        </div>
        <div class="blogCard__content mt-20">
          <div class="blogCard__category">Delay Analysis & EOT Claims</div>
          <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>
          <h4 class="blogCard__title text-18 lh-15 fw-500 mt-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
              <path
                d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                stroke="#94AD04" stroke-width="1.5" />
            </svg>
            By Ali Katary, Expert Engineer.
          </h4>
          <div class="blogCard__date mt-5">Jan 22, 2024</div>
        </div>
      </router-link>
    </div>

    <div class="col-md-6">
      <router-link to="/blogs/1" class="blogCard -type-1">
        <div class="blogCard__image">
          <img class="w-1/1 rounded-8" src="../../assets/images/home/blog-1.png" alt="image" width="788" height="450" />
        </div>
        <div class="blogCard__content mt-20">
          <div class="blogCard__category">Delay Analysis & EOT Claims</div>
          <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>
          <h4 class="blogCard__title text-18 lh-15 fw-500 mt-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
              <path
                d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                stroke="#94AD04" stroke-width="1.5" />
            </svg>
            By Ali Katary, Expert Engineer.
          </h4>
          <div class="blogCard__date mt-5">Jan 22, 2024</div>
        </div>
      </router-link>
    </div>

    <div class="col-md-6">
      <router-link to="/blogs/1" class="blogCard -type-1">
        <div class="blogCard__image">
          <img class="w-1/1 rounded-8" src="../../assets/images/home/blog-1.png" alt="image" width="788" height="450" />
        </div>
        <div class="blogCard__content mt-20">
          <div class="blogCard__category">Delay Analysis & EOT Claims</div>
          <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>
          <h4 class="blogCard__title text-18 lh-15 fw-500 mt-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
              <path
                d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                stroke="#94AD04" stroke-width="1.5" />
            </svg>
            By Ali Katary, Expert Engineer.
          </h4>
          <div class="blogCard__date mt-5">Jan 22, 2024</div>
        </div>
      </router-link>
    </div>

    <div class="col-md-6">
      <router-link to="/blogs/1" class="blogCard -type-1">
        <div class="blogCard__image">
          <img class="w-1/1 rounded-8" src="../../assets/images/home/blog-1.png" alt="image" width="788" height="450" />
        </div>
        <div class="blogCard__content mt-20">
          <div class="blogCard__category">Delay Analysis & EOT Claims</div>
          <p>A hands-on bootcamp to master delay analysis & EOT claims.</p>
          <h4 class="blogCard__title text-18 lh-15 fw-500 mt-5">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path
                d="M1 15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11H13C14.0609 11 15.0783 11.4214 15.8284 12.1716C16.5786 12.9217 17 13.9391 17 15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15Z"
                stroke="#94AD04" stroke-width="1.5" stroke-linejoin="round" />
              <path
                d="M9 7C10.6569 7 12 5.65685 12 4C12 2.34315 10.6569 1 9 1C7.34315 1 6 2.34315 6 4C6 5.65685 7.34315 7 9 7Z"
                stroke="#94AD04" stroke-width="1.5" />
            </svg>
            By Ali Katary, Expert Engineer.
          </h4>
          <div class="blogCard__date mt-5">Jan 22, 2024</div>
        </div>
      </router-link>
    </div>
    <!--------------------------->
    <!-------Load More Button-------->
    <div class="explore__item text-center mt-60">
      <button class="main-button rotate-svg">
        <span>Load More Articles </span>
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M15.586 10.6569L11.636 6.70692C11.4538 6.51832 11.353 6.26571 11.3553 6.00352C11.3576 5.74132 11.4628 5.49051 11.6482 5.3051C11.8336 5.11969 12.0844 5.01452 12.3466 5.01224C12.6088 5.00997 12.8614 5.11076 13.05 5.29292L18.707 10.9499C18.8002 11.0426 18.8741 11.1527 18.9246 11.2741C18.9751 11.3954 19.001 11.5255 19.001 11.6569C19.001 11.7883 18.9751 11.9184 18.9246 12.0398C18.8741 12.1611 18.8002 12.2713 18.707 12.3639L13.05 18.0209C12.9578 18.1164 12.8474 18.1926 12.7254 18.245C12.6034 18.2974 12.4722 18.325 12.3394 18.3262C12.2066 18.3273 12.0749 18.302 11.952 18.2517C11.8291 18.2015 11.7175 18.1272 11.6236 18.0333C11.5297 17.9394 11.4555 17.8278 11.4052 17.7049C11.3549 17.582 11.3296 17.4503 11.3307 17.3175C11.3319 17.1847 11.3595 17.0535 11.4119 16.9315C11.4643 16.8095 11.5405 16.6992 11.636 16.6069L15.586 12.6569H6C5.73478 12.6569 5.48043 12.5516 5.29289 12.364C5.10536 12.1765 5 11.9221 5 11.6569C5 11.3917 5.10536 11.1373 5.29289 10.9498C5.48043 10.7623 5.73478 10.6569 6 10.6569H15.586Z"
              fill="white" />
          </svg>
        </span>
      </button>
    </div>
  </div>
</template>
